import { IErknmAgreementChange } from 'APIPackage/KnmModule/interfaces/IErknmAgreementChange';
import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { agreementsChangeTypeSelectOptions } from 'KnmPackage/MainModule/constants/agreementsChangeTypeSelectOptions';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { createAgreementChangeReasonSelectOption } from 'CorePackage/CatalogsModule/common/createAgreementChangeReasonSelectOption';
import { convertInitialKnmDateToFormDate } from 'KnmPackage/MainModule/common/convertInitialKnmDateToFormDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';

import { IErknmFormAgreementChange } from '../interfaces/IErknmFormAgreementChange';
import { getSelectOption } from './getSelectOption';

export const convertAgreementsChangeToFormValues = (
  changes: IErknmAgreementChange[] | null,
  state: IRootState,
): IErknmFormAgreementChange[] | undefined => {
  if (!changes) {
    return undefined;
  }

  return changes.map(item => {
    return {
      isNew: false,
      guid: item.guid || undefined,
      signed: item.signed ?? undefined,
      listId: item.guid || undefined,
      types: !item.types
        ? undefined
        : item.types.map(type => {
            return {
              guid: type.guid,
              type: agreementsChangeTypeSelectOptions.find(j => j.value === type.type) as ISelectOption<
                string | number
              >,
            };
          }),
      reasons: item.reasons?.map(reason => createAgreementChangeReasonSelectOption(reason)),
      attachment: item.attachment ? [item.attachment] : undefined,
      termOfExecutionAgreement: convertInitialKnmDateToFormDate(
        item.termOfExecutionAgreement,
        DATE_FORMAT_LONG_FNS,
        SYSTEM_DATE_FORMAT_FNS,
      ),
      updatedAgreementAttachment: item.updatedAgreementAttachment ? [item.updatedAgreementAttachment] : undefined,
      petitionAttachment: item.petitionAttachment ? [item.petitionAttachment] : undefined,
      fioSigner: item.fioSigner || undefined,
      titleSigner: item.titleSigner?.dictId
        ? getSelectOption<DictionaryUUIDsEnum.POSITIONS>(
            state,
            item.titleSigner?.dictId,
            item.titleSigner?.dictVersionId,
          )
        : undefined,
    };
  });
};
